import type { IconData } from '@stacksjs/iconify-core'

export const coffee: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M191.5 376h97A111.627 111.627 0 0 0 400 264.5V248h24a72 72 0 0 0 0-144H80v160.5A111.627 111.627 0 0 0 191.5 376M400 136h24a40 40 0 0 1 0 80h-24Zm-288 0h256v128.5a79.59 79.59 0 0 1-79.5 79.5h-97a79.59 79.59 0 0 1-79.5-79.5ZM16 416h480v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default coffee
